<template>
  <el-dialog title="绑定页面" :visible.sync="changeFormVisible" append-to-body :close-on-click-modal="false">
    <el-form :model="changeForm" :rules="rules">
      <el-form-item label="页面" prop="customPageId">
        <el-select v-model="changeForm.customPageId" placeholder="请选择页面" filterable>
          <el-option
              v-for="item in pageOptions"
              :key="item.id"
              :label="item.title+(item.remarks?'('+item.remarks+')':'')"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <p style="color: red;padding-left: 10px">注：只可以更换属于同一产品的页面</p>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="changeFormVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitChange">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { selectPageList } from '@/api/customPageBatch.js'
import {fetchBindPage} from '@/api/customPage.js'

export default {
  name: 'BindPageDialog',
  data() {
    return {
      classId:'',
      isBox:false,
      changeFormVisible: false,
      submitLoading: false,
      pageOptions: [],
      changeForm: {
        customPageId: '',
        batchId: '',
      },
      rules: {
        customPageId: [
          { required: true, message: '请选择页面', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    getPageList() {
      selectPageList({classId:this.classId,isBox:this.isBox}).then(res => {
        this.pageOptions = res.data
      })
    },
    open(batchId,classId,isBox) {
      this.isBox = false
      if (isBox){
        this.isBox = isBox
      }
      if (classId){
        this.classId = classId
      }
      this.changeForm.batchId = batchId
      this.changeForm.customPageId = ''
      this.getPageList()
      this.changeFormVisible = true
    },
    submitChange() {
      this.submitLoading = true
      fetchBindPage(this.changeForm).then(res => {
        if (res.code == 200) {
          this.$message({
            message: '绑定成功',
            type: 'success'
          })
          this.changeFormVisible = false
          this.$emit('success')
        }
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>
